module.exports = __webpack_public_path__ + "img/38.1bc8d214.jpg";